import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// If you plan to use other services like Firestore or Storage on the client,
// you'd also import their respective modules, e.g.:
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";

const firebaseConfig = {
  // IMPORTANT: Replace these placeholder values with the actual ones from your Firebase Console!
  // These are unique to the specific Web App you registered in your 'pdfer3-b41a2' project.
  apiKey: "AIzaSyAhqE4hw1lyUOB6D_4FNdL34dcIhkty1Dg",
  appId: "1:640874257134:web:ebecdfc82fbba2a7f671ff",
  
  // These values are derived from your project details:
  authDomain: "pdfer3-b41a2.firebaseapp.com",
  projectId: "pdfer3-b41a2",
  storageBucket: "pdfer3-b41a2.appspot.com",
  messagingSenderId: "640874257134", // This is your Project Number
  
  // Your Google Analytics measurement ID:
  measurementId: "G-S3B5NX4E1P", 
};

// Initialize the Firebase app with the configuration for pdfer3-b41a2
const app = initializeApp(firebaseConfig);

// Export Firebase Authentication instance
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// You would export other service instances if you needed them:
// export const db = getFirestore(app);
// export const storage = getStorage(app);

// Export the initialized app instance
export default app;



// IMPORTANT: How to find your actual API Key and App ID for 'pdfer3-b41a2':
// 1. Go to your Firebase Console (console.firebase.google.com).
// 2. Select your 'pdfer3-b41a2' project.
// 3. Click the gear icon (⚙️) next to "Project overview", then select "Project settings".
// 4. Scroll down to the "Your apps" card.
// 5. If you haven't registered a web app yet, click the "</>" icon to add a web app.
//    If you already have a web app registered, click on it.
// 6. Select the "Config" option for the Firebase SDK snippet.
// 7. Copy the `apiKey` and `appId` values from the snippet and paste them above.
